// extracted by mini-css-extract-plugin
export var accountContent = "newsletter-module--account-content--nNQmR";
export var newsletter = "newsletter-module--newsletter--ct10J";
export var sectionHeader = "newsletter-module--section-header--3vDiT";
export var sectionHeaderDescription = "newsletter-module--section-header-description--OC9Ft";
export var sectionHeaderTitle = "newsletter-module--section-header-title--MxcJB";
export var text = "newsletter-module--text--nlaZk";
export var title = "newsletter-module--title--l2XFu";